import React, { useState, useEffect } from "react";
import IQStar from "images/iq/iq_star.svg";
import OpenAI from "images/iq/open_ai.svg";
import { QUESTION_BANK } from "./const";

export const Typewriter = ({ questions, className, typingDelay = 50, changingDelay = 2000 }) => {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);

  useEffect(() => {
    if (subIndex < questions[questionIndex].length) {
      const typeTimeout = setTimeout(() => {
        setSubIndex(subIndex + 1);
      }, typingDelay);
      return () => clearTimeout(typeTimeout);
    }
    const nextQuestionTimeout = setTimeout(() => {
      setQuestionIndex((prevIndex) => (prevIndex + 1) % questions.length);
      setSubIndex(0);
    }, changingDelay);
    return () => clearTimeout(nextQuestionTimeout);

  }, [subIndex, questionIndex, questions, typingDelay, changingDelay]);

  return (
    <div className={className}>
      <p>{questions[questionIndex].substring(0, subIndex)}</p>
    </div>
  );
};

export const LandingDefault = ({ belowMd, setRenderChat }) => {
  return (
    <div
      className="flex h-full flex-col md:flex-row text-white"
      style={{ letterSpacing: -0.25, lineHeight: 1.2 }}
    >
      {/* SEC 1 */}
      <div className="bg-neutral-700 text-white flex-1 h-1/2 md:h-full flex flex-col justify-center items-start p-10 md:p-16">
        <img alt="" src={IQStar} className="w-6 h-6" />
        <div className="mt-2 font-bold text-lg">Get instant answers to your credit questions</div>
        <div className="mt-6 h-40">
          <Typewriter
            questions={QUESTION_BANK}
            className={`font-medium ${belowMd ? "text-2xl" : "text-3xl"}`}
          />
        </div>
      </div>

      {/* SEC 2 */}
      <div className="bg-white text-black flex-1 h-1/2 md:h-full flex flex-col justify-start md:justify-center items-center md:items-start p-10 pt-16 md:p-16" style={{ lineHeight: 1.1 }}>
        <h1 className="font-bold text-center md:text-left" style={{ fontSize: belowMd ? 36 : 68 }}>Your AI Financial Assistant</h1>
        <div className="mt-6 md:mt-10 flex flex-col md:flex-row items-center gap-4">
          <button
            type="button"
            className="bg-black text-white hover:bg-neutral-600 focus:bg-neutral-700 rounded-md px-4 h-10 font-medium w-full"
            style={{ width: belowMd ? 256 : undefined }}
            onClick={() => setRenderChat(true)}
          >
            Try it for free
          </button>
          <img className="h-6 w-auto" alt="" src={OpenAI} />
        </div>
      </div>
    </div>
  );
};